module.exports = __webpack_public_path__ + "static/IncidentChart_1-4bf5540d6279271214215a033d689647.png";